import jQuery from 'jquery'
const $ = jQuery
export { $, jQuery }
